import { useRoute, useRuntimeConfig } from 'nuxt/app';

import { useModalStore } from '~~/common/stores/modal';
import { useAuthenticationStore } from '~~/common/stores/authentication';
import { useConfigStore } from '~~/common/stores/config';
import { useUserInterfaceStore } from '~~/common/stores/userInterface';
import { useToasterStore } from '~~/common/stores/toaster';

type ToasterAttributes = Parameters<ReturnType<typeof useToasterStore>['push']>[0];

interface LoginModalData {
  loadingId?: string;
  showToaster?: boolean;
  toasterAttributes?: ToasterAttributes;
  customClose?: unknown;
}

function isSalesforceLoginMaintenanceEnabled () {
  return useConfigStore().configCommon?.persistentConfig?.salesforce_login_maintenance;
}

function isSalesForceLogin () {
  return useConfigStore().isSalesForceLogin;
}

export async function openLoginModal (data?: LoginModalData) {
  const userInterfaceStore = useUserInterfaceStore();

  const navigateToLogin = async () => {
    const modalStore = useModalStore();
    const route = useRoute();
    if (!isSalesForceLogin()) {
      modalStore.showLoginAndRegistrationModal(data);
    } else if (isSalesforceLoginMaintenanceEnabled()) {
      openLoginMaintenanceModal();
    } else {
      const authenticationStore = useAuthenticationStore();
      await authenticationStore.customerDiamondLogin({ path: route.fullPath });
    }
  };

  if (data?.loadingId) {
    userInterfaceStore.startLoading({ id: data.loadingId });
  }
  if (data?.showToaster && data?.toasterAttributes) {
    const toasterStore = useToasterStore();
    const authenticationStore = useAuthenticationStore();

    const logout = authenticationStore.logout();
    toasterStore.push({
      ...data.toasterAttributes,
      closeAfter: 7000,
      callback: async () => {
        await logout;
        await navigateToLogin();
        if (data?.loadingId) {
          userInterfaceStore.endLoading({ id: data.loadingId });
        }
      },
    });
  } else {
    await navigateToLogin();
    if (data?.loadingId) {
      userInterfaceStore.endLoading({ id: data.loadingId });
    }
  }
}

export async function openRegistrationModal (data?: LoginModalData) {
  const modalStore = useModalStore();
  const config = useRuntimeConfig();
  const route = useRoute();
  if (config.public.isRegistrationDisabled) {
    alert('A funkció egyenlőre nem elérhető!');
    return;
  }
  if (!isSalesForceLogin()) {
    modalStore.showLoginAndRegistrationModal(data);
  } else if (isSalesforceLoginMaintenanceEnabled()) {
    openLoginMaintenanceModal();
  } else {
    const authenticationStore = useAuthenticationStore();
    await authenticationStore.customerDiamondRegistration({ path: route.fullPath });
  }
}

function openLoginMaintenanceModal () {
  const modalStore = useModalStore();
  modalStore.openStartPopup();
}
